import React, { Component } from 'react';
import { StyledTooltip } from './style';

class Tooltip extends Component {
  constructor(props) {
    super(props);

    this.state = {
      active: false
    };
  }

  toogleTooltip = active => {
    this.setState({
      active: !active
    });
  };

  render() {
    const { children } = this.props;
    const { active } = this.state;

    return (
      <StyledTooltip
        active={active}
        onClick={() => this.toogleTooltip(active)}
        onBlur={() => this.toogleTooltip(active)}
      >
        {children}
      </StyledTooltip>
    );
  }
}

export default Tooltip;
